import React from 'react';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';

const PropgramsCell = ({ dataKey, rowData, ...props }) => (
  <Table.Cell {...props}>{map('name', rowData[dataKey]).join(', ')}</Table.Cell>
);

PropgramsCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({ programs: PropTypes.arrayOf(PropTypes.shape({})) })
};

PropgramsCell.defaultProps = {
  rowData: null
};

export default PropgramsCell;
